import useSWR from 'swr';
import graphqlApi from '../api/graphqlApi';
import { getShopifyCollection } from './queries/shopifyCollection';
import { ShopifyCollectionResponse } from '../../models/Collection';

const useShopifyCollectionNameSWR = (handle: string) => {
    const fetchAllCollectionItem = (
        query
    ): Promise<ShopifyCollectionResponse> => {
        return graphqlApi
            .post(query)
            .then((res) => {
                return res && res.collectionByHandle
                    ? res.collectionByHandle
                    : null;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        getShopifyCollection(handle),
        fetchAllCollectionItem,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        collection: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useShopifyCollectionNameSWR;
